import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as InventariosService from 'services/inventario.service'
import * as KardexService from 'services/facturacion.service'

import { MesContabilidadSelect } from 'sharedComponents/select'

import { DownloadAxiosFile } from 'utils'

const ReporteEntradasSalidas = () => {
  const __zariContext = React.useContext(ZariContext)

  const [mesSeleccionado, setMesSeleccionado] = React.useState()
  const [resultados, setResultados] = React.useState(null)
  const [buscando, setBuscando] = React.useState(false)

  const clickDescargarReporteEntradasSalidas = React.useCallback(() => {
    __zariContext.loader.open('Descargando Reporte Transferencias...')
    KardexService.descargarReporteEntradasSalidas({ mesSeleccionado })
      .then(({ data, headers }) => { DownloadAxiosFile.downloadAsBlob(data, headers) })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => { __zariContext.loader.close() })
  }, [__zariContext, mesSeleccionado])

  const clickBuscar = React.useCallback(() => {
    setBuscando(true)
    InventariosService.consultaEntradasSalidas({ mesSeleccionado })
      .then(({ data }) => setResultados(data))
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'Error al consultar'))
      .finally(() => setBuscando(false))
  }, [__zariContext, mesSeleccionado])

  return (
    <Portlet>
      <Portlet.Header title='Reporte Transferencias' />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='MES' htmlFor='select-mes' md={2} alignRightAt='md' />
              <Col md={10}>
                <MesContabilidadSelect name='select-mesContabilidad-cruce2' id='select-mesContabilidad-cruce2' value={mesSeleccionado} onChange={e => setMesSeleccionado(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button variant='outline-primary' onClick={clickBuscar} disabled={buscando} className='mr-2'>
              {buscando ? 'Buscando...' : 'Buscar'}
            </Button>
            <Button onClick={clickDescargarReporteEntradasSalidas}>Descargar Reporte</Button>
          </Col>
        </Row>

        {resultados && (
          <Row className='mt-3'>
            <Col md={12}>
              <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                <table className='table table-sm table-striped table-bordered'>
                  <thead>
                    <tr>
                      <th>SEDE</th>
                      <th>USUARIO</th>
                      <th>T.DOC</th>
                      <th>SERIE</th>
                      <th>NUMERO</th>
                      <th>PRODUCTO</th>
                      <th>FECHA</th>
                      <th className='text-right'>CANTIDAD</th>
                      <th>U.M.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((r, i) => (
                      <tr key={i}>
                        <td>{r.sede}</td>
                        <td>{r.usuario}</td>
                        <td>{r.tipoDocumento}</td>
                        <td>{r.serie}</td>
                        <td>{r.numero}</td>
                        <td>{r.producto}</td>
                        <td>{r.fecha}</td>
                        <td className='text-right'>{r.cantidad}</td>
                        <td>{r.unidadMedida}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <small className='text-muted'>{resultados.length} registros encontrados</small>
            </Col>
          </Row>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteEntradasSalidas)
